import React from "react";
import { Tab, Image, Grid, Card, Popup } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import iconInitiativeNormal from '../../../../images/icons-team-dashboard/icon-initiatives-normal.svg'
import iconInitiativeActive from '../../../../images/icons-team-dashboard/icon-initiatives-active.svg'
import iconInvitationsNormal from '../../../../images/icons-team-dashboard/icon-invitations-normal.svg'
import iconInvitationsActive from '../../../../images/icons-team-dashboard/icon-invitations-active.svg'
import iconStreamNormal from '../../../../images/icons-team-dashboard/icon-stream-normal.svg'
import iconStreamActive from '../../../../images/icons-team-dashboard/icon-stream-active.svg'
import iconUsersNormal from '../../../../images/icons-team-dashboard/icon-users-normal.svg'
import iconUsersActive from '../../../../images/icons-team-dashboard/icon-users-active.svg'
import iconTeamsNormal from '../../../../images/icons-team-dashboard/icon-teams-normal.svg'
import iconTeamsActive from '../../../../images/icons-team-dashboard/icon-teams-active.svg'
import TeamsListView from '../drive/TeamsView/TeamsListView'
import OrganizationRecentUpdates from "../drive/cards/OrganizationRecentUpdates";
import UserListView from '../drive/TeamsView/UserListView';
import InitiativeCard from '../drive/cards/InitiativeCard';
import StreamingData from "../../home/Drive/Cards/StreamingData";
import TeamNameAndMemberDetail from "../drive/cards/TeamNameAndMemberDetail";
import NoDataToDisplay from "../../../common/NoDataToDisplay";
import InvitationListView from "../drive/TeamsView/InvitationListView";
import _ from 'lodash';
import BreadCrumbOrganization from "../drive/cards/BreadCrumbOrganization";
import EventDetailsNotFound from './../../home/Drive/Modal/EventDetailsNotFound';
class SubOrganizationTeamDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = { activeIndex: 0 }

    }

    handleTabChange = async (e, data) => {
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        dispatch.organizationUnit.showResourecePane(null);
        this.setState({ activeIndex: data.activeIndex })
        if (data.activeIndex === 0) {

        }
        else if (data.activeIndex === 1) {

        }
        else if (data.activeIndex === 2) {
            await dispatch.invite.storeUserRole('users');
            await dispatch.organizationTab.getUsersTreeAsync({ id: this.props.match.params.teamId, accountId: this.props.match.params.accountId });
        }
        else if (data.activeIndex === 3) {
            await dispatch.invite.storeUserRole('Invitations');
            let query = {
                $sort: { createdAt: 1 },
                $skip: 0,
                $limit: this.props.teamsListViewFlag ? 10 : 50
            }
            let payload = {
                query: query,
                organizationId: this.props.match.params.workspaceId,
                referenceId: this.props.match.params.teamId
            };
            await dispatch.invite.getInvitesAsync(payload);
        }
        else if (data.activeIndex === 4) {
            await dispatch.initiatives.getAllInitiativeByTeamId({
                "accountId": this.props.match.params.accountId,
                "organizationId": this.props.match.params.workspaceId,
                "teamId": this.props.match.params.teamId
            });
        }

    }

    componentWillMount() {
        this.getStart();
    }
    async getStart(nextProps) {
        let payL = {
            limit: 50,
            type: ['practices', 'initiatives', 'contents'],
            teamId: nextProps ? nextProps.match.params.teamId : this.props.match.params.teamId
        }
        if (!this.props.selectedSubOrg || this.props.selectedSubOrg === null) {
            await dispatch.organizationUnit.getSubOrgByIdAsync(nextProps ? nextProps.match.params.teamId : this.props.match.params.teamId);
        }
        dispatch.app.showToolbar(false)
        dispatch.notifications.getEventStreamForTeamId(payL);
        dispatch.notifications.getRecentUpdatesForTeamId({ limit: 20, teamId: nextProps ? nextProps.match.params.teamId : this.props.match.params.teamId });
        dispatch.organizationTab.getUsersTreeAsync({ id: nextProps ? nextProps.match.params.teamId : this.props.match.params.teamId, accountId: this.props.match.params.accountId });
        let query = {
            $sort: { createdAt: 1 },
            $skip: 0,
            $limit: this.props.teamsListViewFlag ? 10 : 50
        }
        let payload = {
            query: query,
            organizationId: this.props.match.params.workspaceId,
            referenceId: nextProps ? nextProps.match.params.teamId : this.props.match.params.teamId
        };
        dispatch.invite.getInvitesAsync(payload);

        let temp = {
            query: query,
            teamId: nextProps ? nextProps.match.params.teamId : this.props.match.params.teamId
        };
        dispatch.organizationUnit.getSubOrgByParentIdAsync(temp)
        dispatch.users.userTreeSelectedPath(null)
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match.params.teamId.toString() !== nextProps.match.params.teamId.toString()) {
            this.setState({ activeIndex: 0 })
            this.getStart(nextProps);
        }
    }

    render() {


        const { activeIndex } = this.state
        const panes = [
            {
                menuItem: {
                    key: 'Events', content:
                        <Popup className="popupStyled" position="bottom center" inverted trigger={<Image src={activeIndex === 0 ? iconStreamActive : iconStreamNormal} style={{ height: "14px" }} />}
                            content='Events'
                        />
                },
                render: () =>
                    <Grid>
                        <Grid.Row className="pad_0">
                            <Grid.Column width={11} style={{ padding: "0 5px 0 0" }} >
                                <Card className="w_100">
                                    <Card.Content className="pad_0" >
                                        <StreamingData
                                            show="all"
                                            initiativeOwnerDetails={this.props.initiativeOwnerDetails}
                                            selectedAccount={this.props.selectedAccount}
                                            notificationsCount={this.props.notificationsCount}
                                            selectedOrganisation={this.props.selectedOrganisation}
                                            loaderEventData={this.props.loaderEventStreamForTeam}
                                            eventStreamArray={this.props.eventStreamArrayForTeam}
                                            eventPage="Team"
                                            noEventDataFound={this.props.noEventDataFound}
                                        />
                                    </Card.Content>
                                </Card>
                            </Grid.Column>
                            <Grid.Column width={5} style={{ padding: "0 0 0 5px" }}>
                                <Card className="w_100">
                                    <Card.Header className="pad_10">Recent Updates</Card.Header>
                                    <Card.Content className="pad_0" >
                                        <OrganizationRecentUpdates
                                            eventPage="Team"
                                            recentUpdates={this.props.recentUpdatesForTeam}
                                            loaderRecentUpdates={this.props.loaderRecentUpdatesForTeam}
                                        />
                                    </Card.Content>
                                </Card>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>,
            },
            {
                menuItem: {
                    key: 'Sub Teams', content:
                        <Popup className="popupStyled" position="bottom center" inverted trigger={<Image src={activeIndex === 1 ? iconTeamsActive : iconTeamsNormal} style={{ height: "14px" }} />}
                            content='Sub Teams'
                        />
                },
                render: () =>
                    <div>
                        {this.props.subOrgs && this.props.subOrgs.data && this.props.subOrgs.data.length === 0 ?
                            <NoDataToDisplay /> :
                            <TeamsListView subOrgs={this.props.subOrgs} {...this.props} />
                        }
                    </div>,
            },
            {
                menuItem: {
                    key: 'Users', content:
                        <Popup className="popupStyled" position="bottom center" inverted trigger={<Image src={activeIndex === 2 ? iconUsersActive : iconUsersNormal} style={{ height: "14px" }} />}
                            content='Users'
                        />
                },
                render: () =>
                    <div>
                        {this.props.usersList &&
                            this.props.usersList.length === 0 ?
                            <NoDataToDisplay />
                            :
                            <UserListView usersList={this.props.usersList}
                                {...this.props}
                            />
                        }
                    </div>,
            },
            {
                menuItem: {
                    key: 'Invitations', content:
                        <Popup className="popupStyled" position="bottom center" inverted trigger={<Image src={activeIndex === 3 ? iconInvitationsActive : iconInvitationsNormal} style={{ height: "14px" }} />}
                            content='Invitations'
                        />
                },
                render: () =>
                    <div>
                        {this.props.invites && this.props.invites.data &&
                            this.props.invites.data.length === 0 ?
                            <NoDataToDisplay />
                            :
                            <InvitationListView invites={this.props.invites}
                                {...this.props}
                            />
                        }
                    </div>,
            },
            {
                menuItem: {
                    key: 'Initiatives', content:
                        <Popup className="popupStyled" position="bottom center" inverted trigger={
                            <Image src={activeIndex === 4 ? iconInitiativeActive : iconInitiativeNormal} style={{ height: "14px" }} />}
                            content='Initiatives'
                        />
                },
                render: () =>
                    <Card.Group className="playbookCardsList" >
                        {this.props.allInitiativesByTeamId && this.props.allInitiativesByTeamId.data &&
                            this.props.allInitiativesByTeamId.data.length ?
                            this.props.allInitiativesByTeamId.data.map(function (initiative, index) {
                                return (
                                    <InitiativeCard
                                        key={index}
                                        selectedInitiative={initiative}
                                        {...this.props}
                                    />
                                );
                            }, this)
                            : <NoDataToDisplay />
                        }
                    </Card.Group>
                ,
            },
        ]
        return (
            <div>
                <BreadCrumbOrganization {...this.props} />
                <TeamNameAndMemberDetail {...this.props} />
                <Tab
                    className="five-block tab-image-center teamDetailTab"
                    menu={{ secondary: true, pointing: true }}
                    panes={panes}
                    onTabChange={this.handleTabChange}
                    activeIndex={this.state.activeIndex}
                />

                <EventDetailsNotFound
                    open={this.props.noEventDataFound}
                />
            </div>

        );
    }
}
export default withRouter(SubOrganizationTeamDetail)
